<template>
  <ResellersPay
    v-if="selectedBill && hasPrivilege('accounting_admins_pay_bill')"
    :selectedBill="selectedBill"
    @updated="billPaid()"
  />

  <div class="modal fade" id="bills-columns" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>

          <div class="text-center">
            <h4 class="mb-4">{{ $t("bills.bills_columns") }}</h4>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="code"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-file-invoice"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.code") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="code"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="receiver"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-user"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.receiver") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="receiver"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="account"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-user-cog"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.account") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="account"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="pprofile"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-id-badge"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.profile") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="pprofile"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="price"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-currency-dollar"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.price") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="price"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="paid"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-cash"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.paid_amount") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="paid"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="from"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-calendar-plus"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.from_date") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="from"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="to"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-calendar-minus"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.to_date") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="to"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="notes"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-notes"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.notes") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="notes"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="paymentDate"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-calendar-check"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.invoice.issued_date") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="paymentDate"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="lastModified"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-clock-edit"></i>
                      <span class="custom-option-title">
                        {{ $t("bills.invoice.updated_at") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="lastModified"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card mb-2">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <!-- <div
              class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0 "
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-danger waves-effect waves-light"
                    @click="confirmDeleteAllBills"
                  >
                    <span>
                      <i class="ti ti-trash ti-xs me-2"></i>
                      <span>Delete All Bills</span>
                    </span>
                  </button>
                </div>
              </div>
            </div> -->
            <div
              class="col-12 col-md-12 d-flex align-items-center justify-content-between flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div class="flex flex-wrap gap-2">
                <div>
                  <label for="">{{ $t("bills.search_from_date") }}</label>
                  <input
                    type="date"
                    v-model="filters.created_at0"
                    class="form-control"
                  />
                </div>
                <div>
                  <label for="">{{ $t("bills.search_to_date") }}</label>
                  <input
                    type="date"
                    v-model="filters.created_at1"
                    class="form-control"
                  />
                </div>
                <div class="flex flex-col align-items-end justify-content-end">
                  <button
                    :disabled="
                      filters.created_at0 == '' || filters.created_at1 == ''
                    "
                    @click.prevent="
                      fetchTotal();
                      applyFilters();
                    "
                    class="btn btn-primary"
                  >
                    {{ $t("bills.filter") }}
                  </button>
                </div>
                <div
                  v-if="filters.created_at0 != '' || filters.created_at1 != ''"
                  class="flex flex-col align-items-end justify-content-end"
                >
                  <button
                    @click.prevent="
                      filters.created_at0 = '';
                      filters.created_at1 = '';
                      fetchTotal();
                      applyFilters();
                    "
                    class="btn btn-danger"
                  >
                    {{ $t("bills.clear") }}
                  </button>
                </div>
              </div>
              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    v-model="filters.search_query"
                    v-if="hasPrivilege('accounting_admins_search_bills')"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6 mt-4  mt-md-0" bis_skin_checked="1">
            <div
              class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                    v-model="filters.rows"
                    @change="applyFilters"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <!-- <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#bills-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div> -->
            </div>
            <div
              class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('resellers_bills_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('resellers_bills_table', 'resellers_bills')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="
                          export_pdf('resellers_bills_table', 'resellers_bills')
                        "
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="resellers_bills_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th>#</th>
                    <th>{{ $t("bills.code") }}</th>
                    <th>{{ $t("transactions.username") }}</th>
                    <th>{{ $t("admins.first_name") }}</th>
                    <th>{{ $t("admins.email") }}</th>
                    <th>{{ $t("bills.price") }}</th>
                    <th>{{ $t("bills.paid_amount") }}</th>
                    <th>{{ $t("bills.notes") }}</th>
                    <th>{{ $t("bills.invoice.issued_date") }}</th>
                    <th>{{ $t("bills.invoice.updated_at") }}</th>
                  </tr>
                  <tr v-if="hasPrivilege('accounting_admins_search_bills')">
                    <th></th>
                    <th></th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.id"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.slug"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <select
                        v-model="filters.user_id"
                        @change="applyFilters"
                        class="form-select form-select-sm"
                      >
                        <option value="-1">{{ $t("control.all") }}</option>
                        <option
                          v-for="admin in admins"
                          :key="admin.id"
                          :value="admin.id"
                          >{{ admin.email }}</option
                        >
                      </select>
                    </th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.admin_name"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <select
                        v-model="filters.admin_email"
                        @change="applyFilters"
                        class="form-select form-select-sm"
                      >
                        <option value="-1">{{ $t("control.all") }}</option>
                        <option
                          v-for="reseller in resellers"
                          :key="reseller.id"
                          :value="reseller.email"
                          >{{ reseller.email }}</option
                        >
                      </select>
                    </th>
                    <th></th>
                    <th>
                      <select
                        v-model="filters.paid"
                        @change="applyFilters"
                        class="form-select form-select-sm"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th>
                      <input
                        type="text"
                        v-model="filters.notes"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        placeholder="yyyy-mm-dd"
                        style="min-width: 7rem;"
                        dir="ltr"
                        v-model="filters.created_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        placeholder="yyyy-mm-dd"
                        style="min-width: 7rem;"
                        dir="ltr"
                        v-model="filters.updated_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th></th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(bill, index) in dataList" :key="bill.id">
                    <td>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class="dropdown-item text-primary"
                              href="#"
                              @click="printBill(bill)"
                            >
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.print") }}
                            </a>
                          </li>
                          <li
                            v-if="
                              (bill.today &&
                                hasPrivilege('accounting_admins_pay_bill')) ||
                                user.type == 'sysadmin'
                            "
                          >
                            <a
                              class="dropdown-item text-danger"
                              @click="deleteBill(bill)"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </a>
                          </li>
                          <li
                            v-if="
                              bill.price > Math.abs(bill.paid) &&
                                hasPrivilege('accounting_admins_pay_bill')
                            "
                          >
                            <a
                              class="dropdown-item text-success"
                              @click.prevent="showPayBillDialog(bill)"
                              href="#"
                            >
                              <i class="ti ti-cash me-2"></i
                              >{{ $t("bills.pay") }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="bill.selected"
                        @click="selectData(bill)"
                      />
                    </td>
                    <td>{{ bill.id }}</td>
                    <td>{{ bill.slug }}</td>
                    <td>{{ bill.user_email }}</td>
                    <td>{{ bill.admin_name }}</td>

                    <td>{{ bill.admin_email }}</td>
                    <td>
                      <span class="badge bg-label-primary">{{
                        bill.price + settings.currency
                      }}</span>
                    </td>
                    <td>
                      <span class="badge bg-label-success">{{
                        bill.paid + settings.currency
                      }}</span>
                    </td>
                    <td>{{ bill.notes }}</td>
                    <td>{{ formatDate(bill.created_at) }}</td>
                    <td>{{ formatDate(bill.updated_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card p-4 mb-2">
      <div class="account-bills-total row g-3">
        <div class="col-md-4">
          <div
            class="alert alert-primary d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-receipt-2 me-2"></i>
              <strong>{{ $t("bills.total.current_grand") }}:</strong>
            </span>
            <strong>{{ current_bills + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-success d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-cash me-2"></i>
              <strong>{{ $t("bills.total.current_paid") }}:</strong>
            </span>
            <strong>{{ current_paid + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-danger d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-report-money me-2"></i>
              <strong>{{ $t("bills.total.current_debt") }}:</strong>
            </span>
            <strong>{{
              current_bills - current_paid + settings.currency
            }}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="card p-4 mb-2">
      <div class="account-bills-total row g-3">
        <div class="col-md-4">
          <div
            class="alert alert-primary d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-calculator me-2"></i>
              <strong>{{ $t("bills.total.total_grand") }}:</strong>
            </span>
            <strong>{{ total_bills + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-success d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-cash me-2"></i>
              <strong>{{ $t("bills.total.total_paid") }}:</strong>
            </span>
            <strong>{{ total_paid + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-danger d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-report-money me-2"></i>
              <strong>{{ $t("bills.total.total_debt") }}:</strong>
            </span>
            <strong>{{ total_bills - total_paid + settings.currency }}</strong>
          </div>
        </div>
      </div>
    </div>
    <div
      id="bill_print_page"
      v-if="selectedBill"
      class="bill-container noScreen"
    >
      <!-- Print button, hidden during printing -->
      <!-- Main bill content -->
      <div class="bill-content">
        <!-- Header with company info -->
        <div class="bill-header text-center">
          <div class="flex justify-center">
            <img :src="server_url + settings.network_logo" class="h-16 w-16" />
          </div>
          <div class="company-name">{{ settings.network_name }}</div>
          <div class="company-name">{{ $t("admins.reseller_bill") }}</div>
        </div>

        <!-- Profile and billing period -->
        <div class="bill-summary">
          <div class="summary-item">
            <span>{{ $t("bills.invoice.bill_to") }}</span>
            <span
              >{{ selectedBill.admin.first_name }}
              {{ selectedBill.admin.last_name }}</span
            >
          </div>
          <div class="summary-item">
            <span>{{ $t("accounts.phone") }}</span>
            <span style="direction: ltr;">{{ selectedBill.admin.phone }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("admins.email") }}</span>
            <span style="direction: ltr;">{{ selectedBill.admin.email }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.invoice.issued_date") }}</span>
            <span>{{ formatDate(selectedBill.created_at) }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.invoice.account_id") }}</span>
            <span>{{ selectedBill.admin.id }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.invoice.bill_id") }}</span>
            <span>{{ selectedBill.id }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.slug") }}</span>
            <span>{{ selectedBill.slug }}</span>
          </div>
        </div>

        <!-- Itemized table -->
        <table class="bill-table">
          <thead>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.description") }}</th>
              <th>{{ $t("bills.invoice.amount") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="2">{{ $t("bills.price") }}</td>
              <td>
                {{ selectedBill.price }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">{{ $t("bills.paid") }}</td>
              <td>
                {{ selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.remaining") }}</th>
              <th>
                {{ selectedBill.price - selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </th>
            </tr>
          </tfoot>
        </table>

        <!-- Issued by and signature -->
        <div class="bill-issuer">
          <div>{{ $t("bills.invoice.issued_by") }}:</div>
          <div>{{ user.first_name }} {{ user.last_name }}</div>
          <div>{{ formatDate(selectedBill.created_at) }}</div>
          <img
            v-if="user.signature"
            :src="server_url + user.signature"
            class="signature"
          />
        </div>

        <!-- Notes -->
        <div v-if="selectedBill.notes" class="bill-notes">
          <div>{{ $t("bills.notes") }}:</div>
          <div>{{ selectedBill.notes }}</div>
        </div>

        <!-- Footer -->
        <div class="bill-footer">
          <div>{{ settings.network_name }}</div>
          <div style="direction: ltr;">{{ settings.phone_number }}</div>
          <div>{{ settings.status_url }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_element,
  print_table,
} from "../global_constants.js";
import { mapGetters } from "vuex";
import ResellersPay from "../components/modals/resellers-pay.vue";
export default {
  name: "Bills",
  components: {
    ResellersPay,
  },
  data() {
    return {
      dataList: null,
      admins: null,
      meta: { last_page: 0 },
      loading: true,
      showFilters: false,
      showPayBill: false,
      showDeleteBill: false,
      selectedBill: null,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        id: "",
        slug: "",
        admin_name: "",
        admin_email: -1,
        user_id: -1,
        paid: "",
        notes: "",
        created_at: "",
        updated_at: "",
        save: false,
        search_query: null,
        created_at0: "",
        created_at1: "",
      },
      resellers: [],
      pdfOptions: {
        margin: 5,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 1, dpi: 96, letterRendering: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
      format: (date) => {
        const day1 = date[0].getDate();
        const month1 = date[0].getMonth() + 1;
        const year1 = date[0].getFullYear();
        const hour1 = date[0].getHours();
        const minute1 = date[0].getMinutes();

        const day2 = date[1].getDate();
        const month2 = date[1].getMonth() + 1;
        const year2 = date[1].getFullYear();

        return `${day1}-${month1}-${year1} -> ${day2}-${month2}-${year2}`;
      },
      exportFilename: "accounts.pdf",
      total_bills: 0,
      total_paid: 0,
      current_bills: 0,
      current_paid: 0,
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
      report_loading: false,
      reportReady: false,
      report: null,
      server_url: localStorage.getItem("server"),
      reportDateStart: "",
      reportDateEnd: "",
      showNotificationConfirm: false,
      notificationMessage: "",
      selectedBill: null,
      allSelected: false,
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  async created() {
    this.prepareFilters();
    if (this.$route.query.username_debt) {
      this.filters.admin_email = this.$route.query.username_debt;
      this.filters.paid = "0";
    }
    if (this.$route.query.reseller_bill_id) {
      this.filters.id = this.$route.query.reseller_bill_id;
    }
    if (this.$route.query.email) {
      this.filters.admin_email = this.$route.query.email;
    }
    this.applyFilters();
    this.fetchTotal();
    this.fetchAdmins();
    this.fetchResellers();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    print_element(id) {
      print_element(id);
    },
    async printBill(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      await this.print_element("bill_print_page");
    },
    prepareFilters() {
      var filters = localStorage.getItem("admin_bills_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "admin/bills?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.user_id != -1)
        requestString += `&user_id=${this.filters.user_id}`;
      if (this.filters.id != "") requestString += `&id=${this.filters.id}`;
      if (this.filters.admin_email != "" && this.filters.admin_email != -1)
        requestString += `&admin_email=${this.filters.admin_email}`;
      if (this.filters.admin_name != "")
        requestString += `&admin_name=${this.filters.admin_name}`;
      if (this.filters.slug != "")
        requestString += `&slug=${this.filters.slug}`;
      if (this.filters.paid != "")
        requestString += `&paid=${this.filters.paid}`;
      if (this.filters.notes != "")
        requestString += `&notes=${this.filters.notes}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.created_at != "") {
        // this.filters.created_at = [
        //   moment(this.filters.created_at[0]).format("yyyy-MM-DD"),
        //   moment(this.filters.created_at[1]).format("yyyy-MM-DD"),
        // ];
        requestString += `&created_at_string=${this.filters.created_at}`;
      }
      if (this.filters.updated_at != "") {
        // this.filters.updated_at = [
        //   moment(this.filters.updated_at[0]).format("yyyy-MM-DD"),
        //   moment(this.filters.updated_at[1]).format("yyyy-MM-DD"),
        // ];
        requestString += `&updated_at_string=${this.filters.updated_at}`;
      }
      if (this.filters.created_at0 != "") {
        this.filters.created_at0 = moment(this.filters.created_at0).format(
          "yyyy-MM-DD"
        );
        requestString += `&created_at0=${this.filters.created_at0}`;
      }
      if (this.filters.created_at1 != "") {
        this.filters.created_at1 = moment(this.filters.created_at1).format(
          "yyyy-MM-DD"
        );
        requestString += `&created_at1=${this.filters.created_at1}`;
      }
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem(
          "admin_bills_filters",
          JSON.stringify(this.filters)
        );
      this.current_bills = 0;
      this.current_paid = 0;
      this.dataList.forEach((bill) => {
        this.current_bills += bill.price;
        this.current_paid += Math.abs(bill.paid);
      });
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem(
      //       "admin_bills_filters",
      //       JSON.stringify(this.filters)
      //     );
      //   this.current_bills = 0;
      //   this.current_paid = 0;
      //   this.dataList.forEach((bill) => {
      //     this.current_bills += bill.price;
      //     this.current_paid += Math.abs(bill.paid);
      //   });
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   this.meta = response.data.meta;
      //   this.loading = false;
      // }, 1000);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    async showPayBillDialog(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      var modalElement = document.getElementById("resellerPayBillsModal");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.selectedBill = null;
      });
      modalInstance.show();
    },
    async fetchTotal() {
      const response = await axios.get("admin/bills/total");
      if (response.status == 200) {
        this.total_bills = response.data.data.total_bills;
        this.total_paid = response.data.data.total_paid;
      }
    },
    async fetchAdmins() {
      const response = await axios.get("adminslog/admins");
      if (response.status == 200) {
        this.admins = response.data.data;
      }
    },
    async fetchResellers() {
      const response = await axios.get("adminslog/admins?type=reseller");
      if (response.status == 200) {
        this.resellers = response.data.data;
      }
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD hh:mm a");
    },
    billPaid() {
      document.getElementById("resellers-pay-bill-close").click();
      this.selectedBill = null;

      this.applyFilters();
    },
    async deleteBill(bill) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("admins.this_will_delete_bill_and_return_credit"),
        icon: "danger",
        showCancelButton: true,
        confirmButtonText: this.$t("bills.yes_delete"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`admin/bills/${bill.id}`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("actions.delete"),
              text: this.$t("bills.bill_has_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            console.log(error);

            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    isValidDate() {
      var dateStringS = this.reportDateStart;
      var dateStringE = this.reportDateEnd;
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      const result =
        dateStringS.match(regEx) != null && dateStringE.match(regEx) != null;
      if (result) {
        this.fetchReport();
      }
    },
    async fetchReport() {
      this.report_loading = true;
      const response = await axios.get(
        `bills/report?report_date_start=${this.reportDateStart}&report_date_end=${this.reportDateEnd}`
      );
      if (response.status == 200) {
        this.report = response.data.data;
        this.report.sum = response.data.sum;
        this.report.count = response.data.count;
        this.reportReady = true;
      }
      this.report_loading = false;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("bills_filters", JSON.stringify(this.filters));
    },
    showBillNotification(bill) {
      if (!bill.account) return;
      this.notificationMessage = "عزيزي المشترك ";
      this.notificationMessage += `هذا الاشعار لتذكيرك بتسديد الفاتورة ذات الرمز: `;
      this.notificationMessage += `${bill.slug}\n`;
      this.notificationMessage += ` من تاريخ: `;
      this.notificationMessage += `${bill.created_at}\n`;
      this.notificationMessage += `وذلك لقاء اشتراك الانترنت `;
      this.notificationMessage += `${bill.profile.name} `;
      this.notificationMessage += `في شبكة `;
      this.notificationMessage += this.settings.network_name + "\n";
      this.notificationMessage += `المطلوب: `;
      this.notificationMessage += `${bill.price}`;
      this.notificationMessage += `${this.settings.currency}\n`;
      this.notificationMessage += `المدفوع: `;
      this.notificationMessage += `${bill.paid}`;
      this.notificationMessage += `${this.settings.currency}\n`;
      this.notificationMessage += `المتبقي: `;
      var remain = bill.price - bill.paid;
      this.notificationMessage += `${remain}`;
      this.notificationMessage += `${this.settings.currency}\n`;
      this.notificationMessage += `مجموع الديون الاجمالي: `;
      this.notificationMessage += `{مجموع_الديون}\n`;
      this.notificationMessage += `بادر بتسديد الفاتورة لضمان استمرارية الخدمة شاكرين تفهمكم\n`;
      this.notificationMessage += `\n`;
      this.notificationMessage += `الخدمة مقدمة من Super Speed Radius`;

      this.showNotificationConfirm = true;
    },
    async sendNotification() {
      this.showNotificationConfirm = false;
      this.loading = true;
      const response = await axios.post(
        `bills/${this.selectedBill.id}/notification`
      );
      if (response.status == 200) {
        this.selectedBill = null;
        this.loading = false;
        this.$router.push({
          query: { success: "success" },
        });
      }
    },
    print_element(element_id) {
      // Get HTML to print from element
      const prtHtml = document.getElementById(element_id).innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <link href="/js/about.js" rel="prefetch">
          <link href="/styles/app.scss" rel="stylesheet">
          <link href="/styles/main.css" rel="stylesheet">
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
<style scoped>
/* Screen styles for preview */
.bill-container {
  margin: 20px auto;
  padding: 10mm;
  background: white;
  font-family: Arial, sans-serif;
}

.bill-content {
  color: black;
  background: white;
}

.bill-header,
.bill-details,
.bill-summary,
.bill-issuer,
.bill-notes,
.bill-footer {
  margin-bottom: 10mm;
}

.bill-header,
.bill-footer {
  text-align: center;
}

.company-logo,
.signature {
  max-height: 80px;
}

.company-name {
  font-size: 1.5rem;
  font-weight: bold;
}

.bill-details {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.customer-info,
.invoice-info {
  flex: 1;
}

.info-row,
.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.bill-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10mm;
}

.bill-table th,
.bill-table td {
  border: 1px solid black;
  padding: 5pt;
  text-align: left;
}

.bill-table th {
  background-color: #f2f2f2;
}

.bill-table tfoot {
  font-weight: bold;
}

.print-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  margin-bottom: 10mm;
}

.print-button:hover {
  background-color: #0056b3;
}

/* Print-specific styles */
@media print {
  .print-button {
    display: none;
  }

  .bill-container {
    margin: 0;
    padding: 5mm;
    font-size: 10pt;
    color: black;
    background: white;
  }

  .bill-table th,
  .bill-table td {
    border: 1px solid black;
    padding: 3pt;
  }

  .bill-table th {
    background: none; /* Remove background for B&W */
  }

  .bill-table,
  .bill-details,
  .bill-summary,
  .bill-issuer,
  .bill-notes {
    page-break-inside: avoid;
  }

  @page {
    size: A4;
    margin: 5mm;
  }

  body * {
    visibility: hidden;
  }

  .bill-container,
  .bill-container * {
    visibility: visible;
  }

  .bill-container {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
